import { Directive, inject } from '@angular/core';
import { ContractConfirmationServiceBase } from '../services/contract-confirmation.service';

@Directive()
export class ContractConfirmationReminderBase {
  public readonly service: ContractConfirmationServiceBase = inject(ContractConfirmationServiceBase);
}
